import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { MenuItem } from 'material-ui';
import { getPriorityIcon } from '../contractingUtils';
import FlatDropDownMenu from '../../tc-ui/flatDropDownMenu';
import ArrowDropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import { JiraFlatButton } from '../../tc-ui/small-buttons';

export const priorities = [
  'Highest',
  'High',
  'Medium',
  'Low',
  'Lowest',
];

class UpdateRateConversionPriority extends Component {
  constructor() {
    super();
  }
  updateRCPriority = newPriority => () => {
    const { contractId, updateRCPriority } = this.props;
    updateRCPriority({ contractId, updater: { priority: newPriority } });
  };
  render() {
    const {
      priority,
      button,
    } = this.props;
    return (
      <FlatDropDownMenu
        button={
          button || (
            <div className="flex-center">
              {getPriorityIcon(priority || 'Medium')}&nbsp;
              <JiraFlatButton
                labelStyle={{ fontSize: '10px' }}
                icon={<ArrowDropDownIcon style={{ fill: 'rgba(0, 0, 0, 0.54)', margin: 0 }}/>}
                labelPosition="before"
                label={priority || 'Medium'}
              />
            </div>
          )
        }
      >
        {
          priorities.map(str => (
            <MenuItem
              key={str}
              primaryText={str}
              disabled={str === priority}
              leftIcon={getPriorityIcon(str)}
              onClick={this.updateRCPriority(str)}
            />
          ))
        }
      </FlatDropDownMenu>
    );
  }
}

UpdateRateConversionPriority.propTypes = {
  updateRCPriority: PropTypes.func,
  contractId: PropTypes.string,
  priority: PropTypes.string,
  button: PropTypes.node,
};

export default connect(null, ({
  updateRCPriority: payload => ({ type: '[contract-request] UPDATE_RATE_CONVERSION_PRIORITY', payload }),
}))(UpdateRateConversionPriority);



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/update-rate-conversion-priority.jsx